.customer-organization-form__administrator-item-container {
  margin-bottom: 3.2rem;

  .customer-organization-form__administrator-item-content-container {
    margin: 3.2rem 0;

    .customer-organization-form__administator-details-container {
      margin: 0.4rem 0;

      .customer-organization-form__administator-details {
        color: #303032;
        width: 360px;

        telia-p {
          margin-bottom: 0.8rem;
        }
      }
    }
  }
}
